<div class="basic-filter" *ngIf="query">
    <div class="all-any-container">
        <div class="all-any" *ngIf="workingQuery">
            <fieldset class="radio-group" style="margin-bottom: 10px;">
                <input class="radio-group-input" type="radio" id="radio-all" [ngModel]="workingQuery.operator"
                       value="AND" />
                <label class="radio-group-label" for="all" (click)="setAll()">All</label>
                <input class="radio-group-input" type="radio" id="radio-any" [ngModel]="workingQuery.operator"
                       value="OR" />
                <label class="radio-group-label" for="any" (click)="setAny()">Any</label>
            </fieldset>
        </div>
        <div class="of-these-conditions-apply">
            <span>of these conditions apply...</span>
        </div>
        <div (click)="setFilterOnPrevious()" title="Filter All Distinct Values By Previous Values"
             class="show-distinct-values-button all font-size-0">
            Filter All Distinct
            <i class="icon-ui-filter" style="vertical-align: top;"
               [ngClass]="{'icon-ui-light-blue': globalFilterOnPrevious, 'icon-ui-gray': !globalFilterOnPrevious}"></i>
        </div>
    </div>
    <div class="subqueries">
        <div *ngFor="let subquery of workingSubqueries; let i = index" class="subquery">
            <div class="when" title="Condition">
                <span *ngIf="i === 0">When</span>
                <span *ngIf="i > 0"><span class="and-or">{{ andOr }}</span> when</span>
            </div>
            &nbsp;
            <div class='field' *ngIf="layerColumnsDisplay">
                <kendo-combobox class="kendo-filter-select" [data]="layerColumnsDisplay" [textField]="'alias'"
                                [valueField]="'name'" [filterable]="true" [valuePrimitive]="true"
                                (filterChange)="handleFilter($event, true)" (valueChange)="selectedFilterColumn(subquery, i)"
                                [popupSettings]="{appendTo: 'component'}" [(ngModel)]="subquery.field"
                                (close)="resetLayerColumnsDisplay()" (closed)="resetLayerColumnsDisplay()" (blur)="resetLayerColumnsDisplay()">
                </kendo-combobox>
            </div>
            &nbsp;<div class="is">is</div>

            <div class="operator">
                <select [(ngModel)]="subquery.operator" (change)="valueChangeOperator(i)" title="Operator">
                    <option [value]="operatorOption.operator" *ngFor="let operatorOption of subquery.operatorOptions">
                        {{ operatorOption.displayText }}</option>
                </select>
            </div>
            <div class="value" [ngClass]="{'null': subquery.inputType === 'null' }">
                <input *ngIf="!subquery.isMultiple && (subquery.inputType !== 'text' && subquery.inputType !== 'null') && !subquery.filterDistinctOnPrevious" [attr.type]="subquery.inputType" [(ngModel)]="subquery.value" title="Value" class="value"
                       [disabled]="subquery.disableValueEntry" tabindex="{{101 + i}}" (change)="valueChange()"
                       (keyup)="valueChange()">
                <kendo-combobox *ngIf="!subquery.isMultiple && (subquery.inputType === 'text' || subquery.filterDistinctOnPrevious)" class="kendo-filter-select"
                                [data]="subquery.filteredDistinctValues" [filterable]="true" (filterChange)="handleFilter($event, false, subquery)"
                                (valueChange)="valueChangeComboBox($event, i)" textField="text" valueField="value" [valuePrimitive]="true" [popupSettings]="{appendTo: 'component'}"
                                [(ngModel)]="subquery.value" [allowCustom]="true" [loading]="subquery.loadingDistinct" (open)="openCloseValueSelection(i)" (close)="openCloseValueSelection(i)" [virtual]="{ itemHeight: 28 }">
                </kendo-combobox>
                <kendo-multiselect *ngIf="subquery.isMultiple && !((subquery.operator == 'BETWEEN' || subquery.operator == 'NOT BETWEEN') && subquery.inputType === 'date')" [data]="subquery.filteredDistinctValues" textField="text" valueField="value" [valuePrimitive]="true"
                                   [loading]="subquery.loadingDistinct" [popupSettings]="{appendTo:'component'}" (valueChange)="valueChangeMultiSelect($event, i)"
                                   [valueNormalizer]="valueNormalizer" [(ngModel)]="subquery.multiValue" [allowCustom]="true" (open)="openCloseValueSelection(i)" (close)="openCloseValueSelection(i)" [virtual]="{ itemHeight: 28 }">
                </kendo-multiselect>
                <ng-container *ngIf="subquery.isMultiple && (subquery.operator == 'BETWEEN' || subquery.operator == 'NOT BETWEEN') && subquery.inputType === 'date'">
                    <input type="date" [(ngModel)]="subquery.multiValue[0]" title="Value" class="value"
                        [disabled]="subquery.disableValueEntry" tabindex="{{101 + i}}" (change)="valueChange()"
                        (keyup)="valueChange()">
                    and
                    <input type="date" [(ngModel)]="subquery.multiValue[1]" title="Value" class="value"
                        [disabled]="subquery.disableValueEntry" tabindex="{{101 + i}}" (change)="valueChange()"
                        (keyup)="valueChange()">
                </ng-container>
            </div>
            <div *ngIf="i > 0" class="toggle-distinct-values font-size-0">
                <span (click)="setFilterOnPrevious(subquery, i)" title="Filter Distinct Values By Previous Values"
                    class="show-distinct-values-button">
                    <i class="icon-ui-filter"
                        [ngClass]="{'icon-ui-light-blue': subquery.filterDistinctOnPrevious, 'icon-ui-gray': !subquery.filterDistinctOnPrevious}"></i>
                </span>
            </div>
            <div class="remove font-size-1" *ngIf="workingSubqueries.length - 1 > i">
                <span (click)="remove(i)" title="Remove">
                    <i class="icon-ui-minus-circled"></i>
                </span>
            </div>
        </div>
    </div>
    <hr>
    <div class="summary">
        <div class="title">Summary:</div>
        <div class="text" [hidden]="!(summaryItemsString.length > 0)">
            {{ summaryItemsString }}
        </div>
    </div>
    <div class="panel show-sql">
        <div class="toggle" (click)="toggleShowSql()">
            <i class="icon-ui-right" [hidden]="showSQL" title="Show SQL Query"></i>
            <i class="icon-ui-down" [hidden]="!showSQL" title="Hide SQL Query"></i>
            <span>Show SQL Query</span>
        </div>
        <div class="sql" [hidden]="!showSQL">{{ workingSql }}</div>
    </div>
    <div class="apply">
        <button class="btn apply-filter" (click)="applyFilter()">Apply Filter to Layer</button>
        <button class="btn btn-clear cancel" (click)="cancel()">Cancel</button>
    </div>
</div>
